import api from '@/libs/axios'

export default {
  async create(payload) {
    let response = await api.post('/admin/is-tag_records', payload)
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/is-tag_records', {params});
    return response
  },
  async update(payload) {
    let response = await api.put('/admin/is-tag_records', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/is-tag_records', {
      data: payload,
    })
    return response
  },
}
